import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { ClickOutside } from 'ui/atoms';
import { useTranslation } from 'react-i18next';

import MainFont from 'ui/typography/mainFont';

import {
  ArrowContainer,
  DownArrow,
  DropdownWrapper,
  Input,
  InputContainer,
  Item
} from './style';

const CustomDropDown = ({
  value,
  name,
  type,
  label,
  arrayData,
  onFocus,
  handleValue,
  readonly,
  isEditing,
  placeholder
}) => {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <ClickOutside
      callback={() => {
        if (showDropdown) {
          setShowDropdown(false);
        }
      }}
    >
      <InputContainer value={value}>
        <Input
          onFocus={onFocus}
          type={type}
          readonly={readonly}
          defaultValue={value}
          name={name}
          onClick={() => !readonly && setShowDropdown(!showDropdown)}
          placeholder={placeholder}
        />
        {!readonly && (
          <ArrowContainer isEditing={isEditing}>
            <DownArrow
              upsideDown={!showDropdown}
              onClick={() => setShowDropdown(!showDropdown)}
            />
          </ArrowContainer>
        )}
        {showDropdown && (
          <DropdownWrapper>
            <Item isNotClickable>
              <MainFont
                type="accountPopupText"
                configuration={{ fontWeight: 'medium' }}
              >
                {t(label)}
              </MainFont>
            </Item>
            {arrayData?.map((item, key) => (
              <Item
                key={key}
                onClick={() => {
                  handleValue({ value: item.value, label: item.label });
                  setShowDropdown(false);
                }}
              >
                <MainFont
                  type="accountPopupText"
                  configuration={{ fontWeight: 'medium' }}
                >
                  {item.label}
                </MainFont>
              </Item>
            ))}
          </DropdownWrapper>
        )}
      </InputContainer>
    </ClickOutside>
  );
};

CustomDropDown.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  handleValue: PropTypes.func,
  isDeleted: PropTypes.string,
  readonly: PropTypes.bool,
  isEditing: PropTypes.bool,
  placeholder: PropTypes.string
};

CustomDropDown.defaultProps = {};

export default CustomDropDown;
